<template>
  <div class="departures__trip">
    <h3 class="departures__trip-title">{{title}}</h3>

    <div class="departures__summary">
      <div class="departures__summary-destination departures__summary-destination--left">
        <time class="departures__summary-time">{{legs[0].departureTime.time}}</time>
        <b class="departures__summary-airport">{{legs[0].departureAirport.code}}</b>
      </div>
      <div class="departures__summary-stops">{{stopsDescription}}</div>
      <div class="departures__summary-destination departures__summary-destination--right">
        <time class="departures__summary-time">{{legs[legs.length - 1].arrivalTime.time}}</time>
        <b class="departures__summary-airport">{{legs[legs.length - 1].arrivalAirport.code}}</b>
      </div>
    </div>

    <div class="departures__flights">
      <template v-for="(leg, index) in legs">
        <div class="departures__flight" :key="`flight${index}`" :class="{ 'departures__flightTs': brand === Brand.Travelsphere }">
          <div class="departures__flight-logo">
            <picture>
              <img :src="leg.flightCarrier.logo.image" :alt="leg.flightCarrier.logo.altText" loading="lazy"/>
            </picture>
          </div>
          <div class="departures__flight-details">
            <p class="departures__flight-carrier">{{leg.flightCarrier.name}}</p>

            <div class="departures__flight-departure">
              <time class="departures__flight-date">{{leg.departureTime.date}}</time>
              <div class="departures__flight-time-wrapper">
                <time class="departures__flight-time">{{leg.departureTime.time}}</time>
                <b class="departures__flight-airport">{{leg.departureAirport.name}}</b>
              </div>
            </div>

            <div class="departures__flight-arrival">
              <time class="departures__flight-time">{{leg.arrivalTime.time}}</time>
              <span class="departures__flight-airport">{{leg.arrivalAirport.name}}</span>
              <time
                class="departures__flight-date"
                v-if="legs[index + 1]"
              >{{legs[index + 1].departureTime.date}}</time>
            </div>
          </div>
        </div>
        <div class="departures__flight-layover" v-if="legs[index + 1]" :key="`layover${index}`">
          <div class="departures__flight-layover-inner">{{layoverTime(index)}}</div>
        </div>
      </template>
    </div>
  </div>
</template>

<script>
import {Brand} from './../../../brand.js';

export default {
  props: ['title', 'legs', 'brand'],

  data() {
    return {
      Brand
    };
  },

  computed: {
    stopsDescription() {
      if (this.legs.length === 1) {
        return null;
      } else {
        const legList = this.legs
          .slice(1)
          .map(leg => leg.departureAirport.code)
          .join(', ');
        if (this.legs.length === 2) {
          return `1 stop - ${legList}`;
        }
        return `${this.legs.length - 1} stops - ${legList}`;
      }
    }
  },

  methods: {
    getFlightDate(legIndex, isDeparture = false) {
      const flight = isDeparture
        ? this.legs[legIndex].departureTime
        : this.legs[legIndex].arrivalTime;
      const flightTime = flight.time.split(':');
      const flightDate = new Date(flight.date);
      flightDate.setHours(flightTime[0]);
      flightDate.setMinutes(flightTime[1]);
      return flightDate;
    },

    layoverTime(legIndex) {
      const arrivalFlight = this.getFlightDate(legIndex);
      const departureFlight = this.getFlightDate(legIndex + 1, true);
      const flightGap = departureFlight - arrivalFlight;
      const hours = Math.floor((flightGap % 86400000) / 3600000);
      const minutes = Math.floor(((flightGap % 86400000) % 3600000) / 60000);
      return `${hours}h ${minutes}m layover`;
    }
  }
};
</script>